import { useNavigate } from 'react-router-dom';
import {
  MagnifyingGlassIcon,
  SparklesIcon,
  ArrowRightIcon,
} from '@heroicons/react/24/outline';

export default function Dashboard() {
  const navigate = useNavigate();

  return (
    <div className="max-w-5xl mx-auto space-y-7 p-6">
      {/* Header */}
      <header className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
        <div>
          <h1 className="text-3xl md:text-4xl font-bold text-primary dark:text-white tracking-tight">
            Recherchieren. Verstehen.<br className="hidden md:block" /> Beraten.
          </h1>
        </div>
        <button
          onClick={() => navigate('/ris')}
          className="btn-primary self-start flex items-center gap-2"
        >
          Neue Suche
          <ArrowRightIcon className="h-4 w-4" />
        </button>
      </header>

      {/* Main Card */}
      <div className="max-w-xl">
        {/* RISearch 2.0 - Featured Card */}
        <button
          onClick={() => navigate('/ris')}
          className="card-soft p-7 text-left w-full"
        >
          <p className="text-xs uppercase tracking-widest text-accent font-semibold mb-2">RIS-Agent</p>
          <h2 className="text-xl font-semibold text-primary dark:text-white mb-2">
            RISearch <span className="text-accent">2.0</span>
          </h2>
          <p className="text-muted dark:text-gray-400 text-sm mb-4">
            KI-gestützte Rechtsrecherche in allen österreichischen Rechtsdatenbanken mit intelligenter Quellenverifikation.
          </p>

          <div className="flex flex-wrap gap-2 mb-6">
            <span className="chip-accent chip">7 Datenbanken</span>
            <span className="chip">Bundesrecht</span>
            <span className="chip">Judikatur</span>
          </div>

          {/* Feature list */}
          <div className="space-y-2 text-xs text-muted dark:text-gray-400">
            <p className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-accent"></span>
              VfGH, VwGH, OGH, BVwG, LVwG
            </p>
            <p className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-accent"></span>
              Strukturierte Ergebnisse mit Quellenangaben
            </p>
            <p className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-accent"></span>
              In-App Dokumentenansicht
            </p>
          </div>
        </button>
      </div>

      {/* Bottom Section - News */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Neuigkeiten */}
        <div className="card-soft p-6">
          <h3 className="font-semibold text-primary dark:text-white mb-3 flex items-center gap-2">
            <SparklesIcon className="h-5 w-5 text-accent" />
            Neuigkeiten
          </h3>
          <ul className="text-sm text-muted dark:text-gray-400 space-y-2">
            <li className="flex items-start gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-accent mt-2 flex-shrink-0"></span>
              <span><strong className="text-primary dark:text-white">RISearch 2.0</strong> - KI-gesteuerte Rechtsrecherche mit Quellenverifikation</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-accent mt-2 flex-shrink-0"></span>
              <span><strong className="text-primary dark:text-white">In-App Viewer</strong> - Dokumente direkt in der Anwendung ansehen</span>
            </li>
          </ul>
        </div>

        {/* In Arbeit */}
        <div className="card-soft p-6">
          <h3 className="font-semibold text-primary dark:text-white mb-3 flex items-center gap-2">
            <SparklesIcon className="h-5 w-5 text-muted" />
            In Arbeit
          </h3>
          <ul className="text-sm text-muted dark:text-gray-400 space-y-2">
            <li className="flex items-start gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-muted/50 mt-2 flex-shrink-0"></span>
              <span>Erweiterte Suchfilter für RISearch</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-muted/50 mt-2 flex-shrink-0"></span>
              <span>Export-Funktionen für Rechercheergebnisse</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-muted/50 mt-2 flex-shrink-0"></span>
              <span>Verbesserte Dokumentenanalyse</span>
            </li>
          </ul>
        </div>
      </div>

      {/* AI disclaimer */}
      <div className="bg-warm-100 dark:bg-gray-800 rounded-2xl p-4 border border-[rgba(30,77,107,0.05)]">
        <p className="text-sm text-muted dark:text-gray-400 text-center">
          KI kann Fehler machen. Eine Überprüfung der Inhalte wird ausdrücklich empfohlen.
        </p>
      </div>
    </div>
  );
}
